import { default as assignTask } from './assignTask';
import { default as chooseTaskType } from './chooseTaskType';
import { default as cleanTask } from './cleanTask';
import { default as deleteTask } from './deleteTask';
import { default as deleteTaskUser } from './deleteTaskUser';
import { default as get } from './get';
import { default as getBusinessTasks } from './getBusinessTasks';
import { default as getCompleted } from './getCompleted';
import { default as getCount } from './getCount';
import { default as getHistory } from './getHistory';
import { default as getTaskedContents } from './getTaskedContents';
import { default as getTasks } from './getTasks';
import { default as getTeamTasks } from './getTeamTasks';
import { default as loadMore } from './loadMore';
import { default as patchTask } from './patchTask';
import { default as sendReminder } from './sendReminder';
import { default as setAssignedUsers } from './setAssignedUsers';
import { default as setCpdAllocation } from './setCpdAllocation';
import { default as setTaskDetails } from './setTaskDetails';
import { default as setTaskSuccess } from './setTaskSuccess';
import { default as updateTask } from './updateTask';
import { default as triggerBusinessSync } from './triggerBusinessSync';
import { default as getBusinessSyncStatus } from './getBusinessSyncStatus';
import { default as triggerTeamSync } from './triggerTeamSync';
import { default as getTeamSyncStatus } from './getTeamSyncStatus';
import { default as getBusinessEmailJobStatuses } from './getBusinessEmailJobStatuses';

export const configurations = [
  assignTask,
  chooseTaskType,
  cleanTask,
  deleteTask,
  deleteTaskUser,
  get,
  getBusinessTasks,
  getCompleted,
  getCount,
  getHistory,
  getTaskedContents,
  getTasks,
  getTeamTasks,
  loadMore,
  patchTask,
  sendReminder,
  setAssignedUsers,
  setCpdAllocation,
  setTaskDetails,
  setTaskSuccess,
  updateTask,
  triggerBusinessSync,
  getBusinessSyncStatus,
  triggerTeamSync,
  getTeamSyncStatus,
  getBusinessEmailJobStatuses
];



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/index.js